<!--
  InvalidPlacementMarker -- flags a product the server hid because a
  placement's location isn't valid for its SKU (card #545, Jake 2026-10-28).
  Shoppers can't see or order it until the placement is moved or removed, so
  the distributor sees it wherever the product is listed (card and products
  table). The editor flags the placement itself (LeftRail).

  `invalid` is the server's `invalid_placement` from the products readiness
  rollup (true when hidden_reason = 'invalid_placement'). Renders nothing
  otherwise.
-->
<template>
  <span
    v-if="invalid"
    :data-testid="testid"
    class="invalid-placement-marker"
    role="img"
    :title="label"
    :aria-label="label"
  >
    <span class="material-icons invalid-placement-marker__icon" aria-hidden="true"
      >warning</span
    >
    <!-- Marker's own text: lets a scenario name THIS marker, not any icon. -->
    <span class="invalid-placement-marker__text">{{ label }}</span>
  </span>
</template>

<script setup>
defineProps({
  invalid: { type: Boolean, default: false },
  testid: { type: String, default: "invalid-placement-marker" },
});

const label =
  "A placement's location isn't valid for this SKU. " +
  "Shoppers can't see or order this product until it's fixed.";
</script>

<style scoped>
.invalid-placement-marker__text {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.invalid-placement-marker__icon {
  font-size: 20px;
  line-height: 1;
  color: #b3261e;
  vertical-align: middle;
}
</style>
